import React, { useEffect, useState } from "react"
import moment from "moment";
import { IoLogoWhatsapp } from "react-icons/io5";
import "./styles.scss"
import { getEsmColorByPercent } from "../../core/utils/esm/getEsmColor";

const Badge = ({ color, textColor, isOpacity = false, isUpperCase = false, label, width }) => {
  const uppercase = isUpperCase && { textTransform: "uppercase" }
  return (
    <div
      className={`badge badge--${color || "primary"} ${isOpacity && "opacity"}`}
      style={{ ...uppercase, color: textColor, width: `${width}px` }}>
      {label}
    </div>
  )
}
export default Badge;

export const BadgeEsm = ({label, type = "high", handleClick, esmId,  ...props}) => {

  const getNewLabel = (label) => {
    if(esmId === "7ea1de77-706a-413f-a9da-cb6f82febcbc") {
      if(label.toLowerCase() == 'ruim') return "MUITO BAIXO";
      else if(label.toLowerCase() == 'baixo') return "BAIXO";
      else if(label.toLowerCase() == 'alto') return "MUITO ALTO";
      else if(label.toLowerCase() == 'bom') return "ALTO";
      else if(label.toLowerCase() == 'médio') return "MÉDIO";
    } 

    return label;
  }


  return (
    <div className={`badge-esm__container ${type} ${handleClick && "badge-click"}`} onClick={handleClick}>
      {getNewLabel(label)}
    </div>
  )
}

export const SessionChatBadge = ({ sessionTime = null, size = 'sm', hasIcon = false }) => {
  const isWithoutSession = !sessionTime || sessionTime[0] === '-';
  const displayTime = isWithoutSession ? "00:00" : sessionTime;

  return (
    <div
      className={`badge-chat ${size === 'lg' ? 'large' : ''} ${isWithoutSession ? 'without-session' : ''}`}
    >
      {hasIcon && (
        <div className={isWithoutSession ? 'without-session-icon_container' : 'icon_container'}>
          <IoLogoWhatsapp />
        </div>
      )}
      {displayTime}
    </div>
  );
};


export const IndicatorBadge = ({ indicatorValue = 0 }) => {
  return (
    <div className="indicator-badge" style={{ backgroundColor: getEsmColorByPercent(indicatorValue) }}>
      <span
        className="indicator-badge-text">
        {indicatorValue && Math.round(indicatorValue) || 0}
      </span>
    </div>
  )
}
